export const statisticQueryKeys = {
  all: () => ['statistic'] as const,
  statistic: (filters: { [k: string]: any }) => [...statisticQueryKeys.all(), { filters }] as const,
};
